<header class="heading-1 row mx-0">
  <div class="col align-middle pl-2">{{strings.SelectProduct}}</div>
  <div class="col-auto h-100 px-4 align-middle">
    <a *ngIf="displayReturnButton" class="return-to-treeview" (click)="returnToSelector()">
      <co-image key="left" width="32px" height="32px"> </co-image>
    </a>
  </div>
</header>